import React, { useEffect, useState } from 'react';
import { listAdminAgents, publishAdminAgent } from '../services/agentApi';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import './ResearchPage.css';

const AdminAgentsPage = () => {
  useDocumentTitle('Admin · Agents');
  const { user, authReady, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!authReady) {
      return;
    }
    if (!isAuthenticated || user?.principalName !== 'admin') {
      navigate('/login', { replace: true });
      return;
    }
    listAdminAgents()
      .then(setAgents)
      .catch((e) => setError(e.message));
  }, [authReady, isAuthenticated, user, navigate]);

  const handlePublish = async (id) => {
    try {
      await publishAdminAgent(id);
      setAgents(await listAdminAgents());
    } catch (e) {
      setError(e.message);
    }
  };

  if (!authReady) {
    return (
      <div className="research-page">
        <div className="container">
          <p>Checking authentication…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="research-page">
      <div className="container">
        <h1>Admin — agents</h1>
        <p>
          <Link to="/admin/feeds">RSS Feeds</Link>
          <Link to="/admin/pipeline-ops">Pipeline Ops</Link>
        </p>
        {error && <p className="research-error">{error}</p>}
        <table className="table">
          <thead>
            <tr>
              <th>Slug</th>
              <th>Name</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {agents.map((a) => (
              <tr key={a.id}>
                <td>{a.slug}</td>
                <td>{a.displayName}</td>
                <td>{a.status}</td>
                <td>
                  {a.status !== 'published' && (
                    <button className="btn btn-sm btn-success" onClick={() => handlePublish(a.id)}>
                      Publish
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminAgentsPage;
